<app-page-header title="Media Types" description="Define the media types available when building a promotion's media plan."></app-page-header>
<!-- stepPosition="center" — see the note in slotting-board-v2.component.html. "right" on a
     full-width grid falls back right -> bottom -> left -> top and ends up clipped off the page. -->
<div class="mediaTypesGrid"
  joyrideStep="settings-add" stepPosition="center"
  [title]="'Set up Media Types'"
  [text]="'Click the + button above the grid to add a media type, fill in the row, then click the checkmark to save.'">
  <dx-data-grid #mediaTypesGrid
  [dataSource]="dataSource"
  [remoteOperations]="false"
  [allowColumnReordering]="false"
  [rowAlternationEnabled]="true"
  [columnAutoWidth]="true"
  [height]="'100%'"
>
  <dxo-editing
    mode="batch"
    [allowAdding]="true"
    [allowUpdating]="true"
    [allowDeleting]="true"
  >
  </dxo-editing>
  <dxi-column dataField="media_type_name" dataType="string" minWidth="200px" caption="Media Type">
    <dxi-validation-rule type="required" message="Media-type name is required"></dxi-validation-rule>
  </dxi-column>
  <dxi-column dataField="media_type_field_type" dataType="string" caption="Data Type">
    <dxi-validation-rule type="required" message="Media type is required"></dxi-validation-rule>
    <dxo-lookup [dataSource]="fieldTypes"></dxo-lookup>
  </dxi-column>
  <dxi-column dataField="export" dataType="boolean" caption="Export"></dxi-column>
  <dxi-column dataField="max" dataType="integer" caption="Max"></dxi-column>
  <dxi-column dataField="id" dataType="integer" [visible]="false"></dxi-column>
</dx-data-grid>
</div>
